export default "__VITE_ASSET__CY3q3XkK__"